import { Box } from '@dtx-company/design-system/src'
import { BuyPlanPageDividerProps } from './BuyPlanPageDividerProps'
import React from 'react'

export function BuyPlanPageDivider(props: BuyPlanPageDividerProps): JSX.Element {
  return (
    <Box
      component="hr"
      {...props}
      sx={{
        backgroundColor: 'rgba(126, 104, 78, 0.24)',
        margin: 0,
        ...props.sx
      }}
    />
  )
}
